import React, { useState } from "react";

//API
import api from "../services/api";
import openToast from "../utils/sweetAlert";

import { useAuth } from "../providers/auth";

//Feather icons
import {
X,
Mic,
MicOff,
Send,
Trash
} from "react-feather";

const RecordView = (props) => {
        
    //Auth
    const { user } = useAuth();
    
    const MicRecorder = require('mic-recorder-to-mp3');
    const [Mp3Recorder] = useState(
        new MicRecorder({ bitRate: 128 })
    );

    const [audio, setAudio] = useState([]);
    const [haveAudio, setHaveAudio] = useState(false);
    const [started, setStarted] = useState(false);
    const [isSending, setIsSending] = useState(false);
  
    const start = () => {
        Mp3Recorder.start().then(() => {
            //
        }).catch((e) => {
            console.error(e);
        });
    }
    const blobToBase64 = blob => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
        });
    };

    const normalizeAudioMimeType = mimeType => {
        const normalized = String(mimeType || "audio/mpeg").toLowerCase();

        return normalized === "audio/mp3" || normalized === "audio/x-mp3"
            ? "audio/mpeg"
            : normalized;
    };

    const getAudioFormat = mimeType => {
        const formats = {
            "audio/aac": ".aac",
            "audio/amr": ".amr",
            "audio/mpeg": ".mp3",
            "audio/mp4": ".m4a",
            "audio/ogg": ".ogg",
        };

        return formats[mimeType.split(";")[0]] || ".mp3";
    };
    const stop = () => {
        Mp3Recorder
            .stop()
            .getMp3().then(([, blob]) => {
                    blob.path = URL.createObjectURL(blob);
                    setAudio(blob);
                    setHaveAudio(true);
            });
    }
  
    const send = async () => {
        if(haveAudio && !isSending)
        {
            setIsSending(true);

            try {
                const mimeType = normalizeAudioMimeType(audio.type);
                let splittedAudio = mimeType.split("/");
                const body = await blobToBase64(audio);
                const response = await api.post(`/messages/send`, {
                    chat_id: props.chat_id,
                    type: splittedAudio[0],
                    body,
                    blob: audio.path,
                    format: getAudioFormat(mimeType),
                    mime_type: mimeType
                }, { headers: { "Authorization": "Bearer " + user.token } });

                if (response.data?.error) {
                    openToast("error", "Ocorreu um erro", response.data.message || "Não foi possível enviar o áudio.");
                    return;
                }

                props.setTrigger(false);
                setAudio([]);
                setHaveAudio(false);
                
                if (props.updateMessagesById) {
                    await props.updateMessagesById(props.chat_id, { force: true });
                }
                if (props.refreshChatsMeta) {
                    await props.refreshChatsMeta();
                } else if (props.updateAllChats) {
                    props.updateAllChats();
                }
            } catch (error) {
                openToast("error", "Ocorreu um erro", error.response?.data?.message || "Não foi possível enviar o áudio.");
            } finally {
                setIsSending(false);
            }
        }
    }
  
    const isRecording = started ? "button__pulse--pushed" : "";

    const buttonStart = (
        <button className="button__pulse button__pulse--active" onClick={e => {e.preventDefault(); setStarted(true); start()}}>
            <Mic />
        </button>
    );
    
    const buttonStop = (
        <button className={`button__pulse button__pulse--active ${isRecording}`} onClick={e => {e.preventDefault(); setStarted(false); stop()}}>
            <MicOff />
        </button>
    );

    const buttonSend = (
        <button className="button__pulse button__pulse--active" onClick={e => {e.preventDefault(); send()}} disabled={isSending}>
            <Send />
        </button>
    );

    const recordState = started ? buttonStop : haveAudio ? buttonSend : buttonStart;

    const isOpen = props.trigger ? "u-d-flex" : "u-d-none";

    const isBtnDisabled = started || isSending ? true : false;
  
    return (
        <div className={`record ${isOpen} u-flex-column u-justify-center u-align-center`}>
            <button type="button" className="record__close-button" onClick={() => {props.setTrigger(false); setHaveAudio(false); setAudio([]);}} disabled={isBtnDisabled}>
                <X />
            </button>

            {recordState}

            {!haveAudio && started && <p className="record__label">Gravando...</p>}

            {isSending && <p className="record__label">Enviando...</p>}

            {!haveAudio && !started && <p className="record__label b">Pressione o botão para começar a gravação</p>}

            <div style={{display: 'flex', flexDirection: 'row', width: '50%'}}>
                {haveAudio && (
                    <button style={{width: '10%'}} type="button" className="action-btn" onClick={(e) => { e.preventDefault(); setHaveAudio(false); setAudio([]);}} disabled={isSending}>
                        <Trash />
                    </button>
                )}

                {haveAudio && (
                    <audio controls style={{width: '90%'}}>
                        <source src={audio.path} />
                    </audio>
                )}
            </div>

        </div>
    );
};
  
export default RecordView;